import {BlockEmbed} from './block';

const MOVEMENT_TYPES = {
  walk: 'Пешеходная',
  bus: 'Автобусная',
  car: 'Автомобильная',
  bicycle: 'Велосипедная',
};

class Excursions extends BlockEmbed {
  static create(value) {
    const node = super.create(value);
    node.setAttribute('contenteditable', false);
    return node;
  }
  
  constructor(scroll, domNode, filters) {
    super(scroll, domNode);
    this.excursions = [];
    this.editMode = false;
    
    if (filters) {
      this.filters = filters;
  
      if (this.filters.editMode) {
        this.editMode = this.filters.editMode;
        delete this.filters.editMode;
      }
      
      this.fetch();
    }
    
    // экскурсии
    const container = document.createElement('div');
    container.className = 'container-list';
    this.domNode.appendChild(container);
    
    this.grid = document.createElement('div');
    this.grid.className = 'list';
    container.appendChild(this.grid);
    
    // контейнер для режима редактирования
    const editContainer = document.createElement('div');
    editContainer.className = 'container-edit';
    this.domNode.appendChild(editContainer);
    
    const editButtons = document.createElement('div');
    editButtons.className = 'buttons';
    editButtons.innerText = 'Редактирование блока экскурсий';
    editContainer.appendChild(editButtons);
  
    this.btnSave = document.createElement('button');
    this.btnSave.setAttribute('type', 'button');
    this.btnSave.innerText = 'Сохранить';
    this.btnSave.addEventListener('click', this.changeMode.bind(this));
    editButtons.appendChild(this.btnSave);
    
    this.btnDestroy = document.createElement('button');
    this.btnDestroy.setAttribute('type', 'button');
    this.btnDestroy.innerText = 'Удалить';
    this.btnDestroy.addEventListener('click', this.remove.bind(this));
    editButtons.appendChild(this.btnDestroy);
    
    this.editGrid = document.createElement('div');
    editContainer.appendChild(this.editGrid);
    
    // кнопка переключения между режимами
    const btnMode = document.createElement('button');
    btnMode.setAttribute('type', 'button');
    btnMode.className = 'btn-mode';
    btnMode.innerText = 'Редактировать';
    btnMode.addEventListener('click', this.changeMode.bind(this));
    this.domNode.appendChild(btnMode);
  }
  
  fetch() {
    this.domNode.dataset.excursions = JSON.stringify(this.filters);
    
    const params = Object.keys(this.filters).map(k => `${encodeURIComponent(k)}=${encodeURIComponent(this.filters[k])}`).join('&');
    const xhr = new XMLHttpRequest();
    xhr.open('GET', API_DOMAIN + '/excursions/widget/?source=1&' + params, true);
    xhr.onload = () => {
      if (xhr.status === 200) {
        this.excursions = JSON.parse(xhr.responseText);
        // this.editMode = this.excursions.length === 0;
        this.updateEditable();
      }
    };
    xhr.send(null);
  }
  
  changeMode() {
    this.editMode = !this.editMode;
    this.updateEditable();
  }
  
  updateGrid() {
    this.grid.innerHTML = '';
    this.excursions.map(excursion => {
      this.grid.appendChild(Excursions.createMarkup(excursion));
    });
  }
  
  updateEditGrid() {
    this.editGrid.innerHTML = '';
  
    const filters = document.createElement('fieldset');
    filters.className = 'filters';
    
    const legend = document.createElement('legend');
    legend.innerText = 'Подбор экскурсий';
  
    const searchField = document.createElement('input');
    searchField.autofocus = true;
    searchField.value = this.filters.search || '';
    searchField.onchange = (e) => {
      this.filters.search = e.target.value;
      this.fetch();
    };
    const searchLabel = document.createElement('label');
    searchLabel.innerText = 'Слово в заголовке';
    searchLabel.appendChild(searchField);
  
    const cityField = document.createElement('input');
    cityField.value = this.filters.city || '';
    cityField.onchange = (e) => {
      this.filters.city = e.target.value;
      this.fetch();
    };
    const cityLabel = document.createElement('label');
    cityLabel.innerText = 'В конкретном городе';
    cityLabel.appendChild(cityField);
  
    const movementTypeField = document.createElement('select');
    
    const opt = document.createElement('option');
    movementTypeField.appendChild(opt);
    for (let mType in MOVEMENT_TYPES) {
      const opt = document.createElement('option');
      opt.value = mType;
      opt.innerHTML = MOVEMENT_TYPES[mType];
      if (mType === this.filters.movementType) {
        opt.setAttribute('selected', true);
      }
      movementTypeField.appendChild(opt);
    }
    movementTypeField.onchange = (e) => {
      this.filters.movementType = e.target.value;
      this.fetch();
    };
    
    const movementTypeLabel = document.createElement('label');
    movementTypeLabel.innerText = 'По типу передвижения';
    movementTypeLabel.appendChild(movementTypeField);
    
    const previewList = document.createElement('div');
    previewList.classList.add('list');
    
    filters.appendChild(legend);
    filters.appendChild(searchLabel);
    filters.appendChild(cityLabel);
    filters.appendChild(movementTypeLabel);
  
    this.editGrid.appendChild(filters);
    this.editGrid.appendChild(previewList);

    this.excursions.map(excursion => {
      previewList.appendChild(Excursions.createMarkup(excursion));
    });
    
    if (this.excursions.length) {
      this.btnSave.style.display = 'block';
      this.btnDestroy.style.display = 'none';
    } else {
      this.btnSave.style.display = 'none';
      this.btnDestroy.style.display = 'block';
    }
  }
  
  refreshGrid() {
    if (this.editMode) {
      this.updateEditGrid();
    } else {
      this.updateGrid();
    }
  }
  
  updateEditable() {
    this.domNode.classList.toggle('edit', this.editMode);
    this.refreshGrid();
  }
  
  static value(domNode) {
    return JSON.parse(domNode.dataset.excursions);
  }
  
  static createMarkup(excursion) {
    const article = document.createElement('article');
    
    const image = document.createElement('div');
    image.classList.add('image');
    const img = document.createElement('img');
    img.src = excursion.photo;
    image.appendChild(img);
    
    const title = document.createElement('h4');
    title.classList.add('title');
    title.innerText = excursion.title;
    
    const details = document.createElement('div');
    details.classList.add('details');
    
    const counters = document.createElement('div');
    counters.classList.add('counters');
    
    const rating = document.createElement('div');
    rating.classList.add('rating');
    rating.setAttribute('title', 'Рейтинг ' + excursion.rating + ' / 10');
    
    for (let i=0; i<10; i=i+2) {
      const star = document.createElement('span');
      star.className = 'fa fa-star';
      if (Math.round(excursion.rating) > i) {
        star.classList.add('checked');
      }
      rating.appendChild(star);
    }
    
    const reviews = document.createElement('span');
    reviews.classList.add('reviews');
    reviews.innerText = excursion.review_count + ' отзывов';
    
    const price = document.createElement('div');
    price.classList.add('price');
    
    const priceValue = document.createElement('span');
    priceValue.classList.add('value');
    priceValue.innerText = Math.round(excursion.price_rub) + ' руб';
    
    const priceLabel = document.createElement('span');
    priceLabel.classList.add('label');
    priceLabel.innerText = 'за ' + (excursion.price_type === 'person' ? 'человека' : 'экскурсию');
    
    price.appendChild(priceValue);
    price.appendChild(priceLabel);
    
    
    counters.appendChild(rating);
    counters.appendChild(reviews);
    
    details.appendChild(counters);
    details.appendChild(price);
    
    article.appendChild(image);
    article.appendChild(title);
    article.appendChild(details);
    
    return article;
  }
  
  add(excursion) {
    this.excursions.push(excursion.photo);
    this.refreshGrid();
  }
}

Excursions.tagName = 'DIV';
Excursions.blotName = 'excursions';
Excursions.className = 'excursions';

export default Excursions;